import Big from 'big.js';
import * as html from 'smg/html';
import * as models from 'smg/models';
import * as template from 'smg/template';
import { DollarFormat } from 'smg/util';
import { ModalOrOffcanvas } from '../modal';

interface myWindow extends Window {
    readonly cloudFront: string;
}
declare const window: myWindow;

export interface QuoteProofForRevision {
    quoteProof: models.QuoteProof;
    quoteLineItem?: models.QuoteLineItem;
}

let $promptProofForRevisionModalTemplate: HTMLTemplateElement;
let $promptProofForRevisionTemplate: HTMLTemplateElement;

export interface PromptProofForRevisionOptions {
    closable?: boolean;
}

// PromptProofForRevision takes a given list of proofs
// and prompts the user to select one of them, returning the quoteProofID
// of the the users selection.
export function PromptProofForRevision(quoteProofs: QuoteProofForRevision[], opts?: PromptProofForRevisionOptions): Promise<string | undefined> {
    if (!quoteProofs.length) {
        return Promise.resolve(undefined);
    }
    if (quoteProofs.length === 1) {
        return Promise.resolve(quoteProofs[0].quoteProof.id);
    }

    if (!$promptProofForRevisionModalTemplate) {
        $promptProofForRevisionModalTemplate = document.querySelector('#prompt-proof-for-revision-modal-template') as HTMLTemplateElement;
    }

    if (!$promptProofForRevisionTemplate) {
        $promptProofForRevisionTemplate = document.querySelector('#prompt-proof-for-revision-template') as HTMLTemplateElement;
    }

    return new Promise((resolve, reject) => {
        const $body = template.Clone($promptProofForRevisionModalTemplate).firstElementChild as HTMLElement;

        const $proofs = $body.querySelector('#modal-proofs') as HTMLElement;

        const $requestRevision = $body.querySelector('#modal-request-revision') as HTMLButtonElement;

        for (const quoteProof of quoteProofs) {
            const $card = template.Clone($promptProofForRevisionTemplate).firstElementChild as HTMLElement;
            html.IDsToClasses($card);

            const $radio = $card.querySelector('.modal-proof-radio') as HTMLInputElement;
            $radio.value = quoteProof.quoteProof.id ?? '';

            // fancybox is actually kind of annoying in this context
            // const $proofLink = $card.querySelector('.modal-proof-link') as HTMLAnchorElement;
            // $proofLink.href = `${window.cloudFront}/${quoteProof.quoteProof.proof?.file ?? ''}`;
            // $proofLink.setAttribute('data-fancybox', quoteProof.quoteProof.id ?? '');
            // $proofLink.setAttribute('data-caption', quoteProof.quoteProof.name ?? '');

            const $proof = $card.querySelector('.modal-proof') as HTMLImageElement;
            $proof.src = `${window.cloudFront}/${quoteProof.quoteProof.proof?.file ?? ''}`;
            $proof.alt = quoteProof.quoteProof.name ?? '';
            $proof.title = quoteProof.quoteProof.name ?? '';

            const $proofName = $card.querySelector('.modal-proof-name') as HTMLElement;
            $proofName.textContent = quoteProof.quoteProof.name ?? '';

            const $productContainer = $card.querySelector('.modal-proof-product-container') as HTMLElement;
            const $product = $card.querySelector('.modal-proof-product') as HTMLElement;

            const $quantityContainer = $card.querySelector('.modal-proof-quantity-container') as HTMLElement;
            const $quantity = $card.querySelector('.modal-proof-quantity') as HTMLElement;

            const $totalContainer = $card.querySelector('.modal-proof-total-container') as HTMLElement;
            const $total = $card.querySelector('.modal-proof-total') as HTMLElement;

            if (quoteProof.quoteLineItem?.lineItem || quoteProof.quoteLineItem?.lineItemModel?.name) {
                $productContainer.classList.remove('d-none');
                $product.textContent = quoteProof.quoteLineItem.lineItemModel?.name ?? '';
            }

            if (quoteProof.quoteLineItem?.quantity) {
                $quantityContainer.classList.remove('d-none');
                $quantity.textContent = quoteProof.quoteLineItem.quantity.toLocaleString();
            }

            if (quoteProof.quoteLineItem?.price && quoteProof.quoteLineItem?.quantity) {
                $totalContainer.classList.remove('d-none');
                $total.textContent = DollarFormat(Big(quoteProof.quoteLineItem.price).times(quoteProof.quoteLineItem.quantity));
            }

            $radio.addEventListener('click', () => {
                $requestRevision.disabled = false;
            });

            $proofs.appendChild($card);
        }

        new ModalOrOffcanvas({
            title: 'Select Proof',
            body: $body,
            width: '42rem',
            appendConfirmButtonClass: 'w-100 w-sm-auto btn-sm-lg mx-auto',
            cancelButton: false,
            outsideClosable: opts?.closable && undefined,
            close: opts?.closable && undefined,
            escape: false,

            onSubmit: () => {
                const $selected = $body.querySelector('.modal-proof-radio:checked') as HTMLInputElement;
                resolve($selected.value);
            },
            onClose: () => reject(),
            appendClassBySelector: {
                '.modal-body': 'px-0 px-md-12',
                '.modal-footer': 'd-none',
                '.modal-title': 'fs-2 fw-900',
                '.modal-header': 'pb-4',

                '.offcanvas-body': 'px-0',
                '.offcanvas-footer': 'd-none',
                '.offcanvas-title': 'fs-4 fw-900',
            },
        });
    });
}